<template>
  <div>
    <b-button-group v-for="(tag, i) in tags" v-bind:key="i">
      <b-button @click="removeTag(i)" variant="outline-primary">{{tag}}</b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  name: 'tag',
  data () {
    return {
      tags: []
    };
  },
  methods: {
    removeTag (i) {
      var ele = this.tags[i];
      this.tags.splice(i, 1);
      this.$emit('del', ele);
    },
    addTag (tag) {
      this.tags.push(tag);
    },
    removeTagByName (name) {
      var i = this.tags.indexOf(name);
      this.removeTag(i);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/Tag.vue